import { useEffect, useState } from "react";
import { useStores } from "../../store";
import Select from "../JobPost/Select";
import Input from "../JobPost/input";
import { AiOutlineLeft } from "react-icons/ai";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import { MdDeleteOutline, MdOutlineAddCircleOutline } from "react-icons/md";
import { useObserver } from "mobx-react";
import Popup from "./Components/skipPopup";
import { apiPostPut } from "../../api/api_methods";
import {
  createInterview,
  updateInterview,
} from "../../api/recruiterAssessmentsApi";
import { uploadFileToAzure } from "../../services/azure";
import { interviewsProList } from "../../helpers/constantVariables";
import Loader from "../reusble_components/loader";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import HelpCenter from "../reusble_components/helpCenter";
import JobShare from "./Components/Job";
import { useLocation } from "react-router-dom";
import PercentageInput from "../JobPost/PercentageInput";

export default function HrInterview({
  skip,
  fromIndex,
  buttonName,
  isEdit,
  interview,
}) {
  const { CommonStore, RecuiterStore, InterviewStore, PopupStore, UserStore } =
    useStores();
  const [showSkip, setShowSkip] = useState(skip ?? true);
  const [interviewType, setInterviewType] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.interviewType || "",
  );
  const [technology, setTechnology] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.technology || "",
  );
  const [noOfQuestions, setNoOfQuestions] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.numberOfQuestions || "",
  );
  const [level, setLevel] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.interviewLevel || "",
  );
  const [attempts, setAttempts] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
      .attempts || 1,
  );
  const [noOfFollowupQuestions, setNoOfFollowupQuestions] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.noOfFollowUps || "",
  );
  const [noOfIntroQuestions, setNoOfIntroQuestions] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.noOfIntroQuestions || "",
  );
  const [allQuestions, setAllQuestions] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.allQuestions || "",
  );
  const [distOpen, setDistOpen] = useState(false);
  const [distTotal, setDistTotal] = useState(0);
  const [distTopic, setDistTopic] = useState(0);
  const [distIntro, setDistIntro] = useState(0);
  const [distFollow, setDistFollow] = useState(0);
  const [distCustom, setDistCustom] = useState(0);
  // Store original values to revert on cancel
  const [originalTopic, setOriginalTopic] = useState(0);
  const [originalIntro, setOriginalIntro] = useState(0);
  const [originalFollow, setOriginalFollow] = useState(0);
  const [noOfCustomQuestions, setNoOfCustomQuestions] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.noOfCustomQuestions || "0",
  );
  const [showCustom, setShowCustom] = useState(false);
  const [customQuestions, setCustomQuestions] = useState(
    RecuiterStore.jobPostDetails.hrInterviewDetails.customquestions || [],
  );
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [invitationLink, setInvitationLink] = useState(null);
  const [clientLink, setClientLink] = useState(null);
  const [waiting, setWaiting] = useState(false);

  const link = () => {
    if (!invitationLink || !clientLink) {
      return {
        jobPostLink: "Interview link not available yet",
        clientLink: "Interview link not available yet",
      };
    }
    const jobPostLink = invitationLink;
    // alert(jobPostLink, clientLink);
    return { jobPostLink: jobPostLink, clientLink: clientLink };
  };

  const [popUpVisible, setPopupVisible] = useState(false);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const id = query.get("id"); // id of the interview

  const setInterviewData = async () => {
    const isSuccess = await RecuiterStore.fetchInterviewDetails(id);
    if (!isSuccess) return;

    const interviewData = RecuiterStore.jobPostApplicant;
    if (!interviewData) return;

    const getSettingValue = (name, fallback = false) =>
      interviewData?.customSettings?.find((setting) => setting.name === name)
        ?.value ?? fallback;

    setInterviewType(
      interviewData.interviewId === 8
        ? "AI HR interview"
        : "Manual HR interview",
    );
    setTechnology(interviewData.technology || "");
    setLevel(interviewData.levelOfInterview || "");
    setNoOfQuestions(interviewData.noOfQuestions ?? "");
    setNoOfIntroQuestions(interviewData.noOfIntroQuestions ?? 0);
    setNoOfFollowupQuestions(interviewData.noOfFollowUps ?? 0);
    setAllQuestions(interviewData.allQuestions ?? "");
    setNoOfCustomQuestions(String(interviewData.noOfCustomQuestions ?? 0));
    setCustomQuestions(interviewData.customQuestions || []);
    setShowCustom(Number(interviewData.noOfCustomQuestions || 0) > 0);
    setAttempts(Number(getSettingValue("attempts", 1)));

    RecuiterStore.sethrAdditionalSettings(
      "camera",
      getSettingValue("video", false),
    );
    RecuiterStore.sethrAdditionalSettings(
      "resume",
      getSettingValue("resume", false),
    );
    RecuiterStore.sethrAdditionalSettings(
      "screen",
      getSettingValue("screen", false),
    );
    RecuiterStore.sethrAdditionalSettings(
      "attempts",
      Number(getSettingValue("attempts", 1)),
    );
    RecuiterStore.setHrInterviewDetails(
      "whoPayCheck",
      interviewData.whoPay === "candidate",
    );
    RecuiterStore.setHrInterviewDetails(
      "resumeCutoff",
      interviewData.cutOff ?? "",
    );
    RecuiterStore.jobPostDetails.customSettings =
      interviewData.customSettings || [];
  };

  useEffect(() => {
    if (id && !window.location.pathname.includes("job-post")) {
      setInterviewData();
    }
  }, [id]);

  useEffect(() => {
    setInterviewType(
      RecuiterStore.jobPostDetails.hrInterviewDetails.interviewType || "",
    );
    setTechnology(
      RecuiterStore.jobPostDetails.hrInterviewDetails.technology || "",
    );
    setNoOfQuestions(
      RecuiterStore.jobPostDetails.hrInterviewDetails.numberOfQuestions || "",
    );
    setLevel(
      RecuiterStore.jobPostDetails.hrInterviewDetails.interviewLevel || "",
    );
    setAttempts(
      RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
        .attempts || 1,
    );
    setNoOfFollowupQuestions(
      RecuiterStore.jobPostDetails.hrInterviewDetails.noOfFollowUps || "",
    );
    setCustomQuestions(
      RecuiterStore.jobPostDetails.hrInterviewDetails.customquestions || [],
    );
    setNoOfIntroQuestions(
      RecuiterStore.jobPostDetails.hrInterviewDetails.noOfIntroQuestions || "",
    );
    setNoOfFollowupQuestions(
      RecuiterStore.jobPostDetails.hrInterviewDetails.noOfFollowUps || "",
    );
    setAllQuestions(
      RecuiterStore.jobPostDetails.hrInterviewDetails.allQuestions || "",
    );
    setNoOfCustomQuestions(
      RecuiterStore.jobPostDetails.hrInterviewDetails.noOfCustomQuestions ||
        "0",
    );
    setShowCustom(
      Number(
        RecuiterStore.jobPostDetails.hrInterviewDetails.noOfCustomQuestions ||
          0,
      ) > 0,
    );
  }, [RecuiterStore.jobPostDetails.hrInterviewDetails]);

  const [minQuestionsError, setMinQuestionsError] = useState("");
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    if (interviewType === "Manual HR interview") {
      const updateQuestionsArray = () => {
        if (noOfQuestions > 20)
          return setMinQuestionsError(
            "Number of questions should be less than or equal to 20",
          );

        if (noOfQuestions < 21) {
          setMinQuestionsError("");
        }
        const updatedQuestionsArray = [...customQuestions];
        const currentLength = updatedQuestionsArray.length;
        const newLength = Number(noOfQuestions);
        if (newLength > currentLength) {
          for (let i = currentLength; i < newLength; i++) {
            updatedQuestionsArray.push("");
          }
        } else if (newLength < currentLength) {
          updatedQuestionsArray.length = newLength;
        }
        setCustomQuestions(updatedQuestionsArray);
        RecuiterStore.setHrInterviewDetails("numberOfQuestions", noOfQuestions);
      };

      if (noOfQuestions && Number(noOfQuestions) !== customQuestions.length) {
        updateQuestionsArray();
      }
    }
  }, [noOfQuestions, interviewType]);

  // Sync customQuestions array length with noOfCustomQuestions for AI HR interviews
  useEffect(() => {
    if (
      interviewType === "AI HR interview" &&
      Number(noOfCustomQuestions || 0) > 0
    ) {
      const customCount = Number(noOfCustomQuestions || 0);
      const currentLength = customQuestions.length;

      if (currentLength < customCount) {
        // Add empty strings to match the count
        const updated = [...customQuestions];
        for (let i = currentLength; i < customCount; i++) {
          updated.push("");
        }
        setCustomQuestions(updated);
      } else if (currentLength > customCount) {
        // Remove extra questions
        setCustomQuestions(customQuestions.slice(0, customCount));
      }
    } else if (
      interviewType === "AI HR interview" &&
      Number(noOfCustomQuestions || 0) === 0
    ) {
      // If noOfCustomQuestions is 0, clear custom questions
      if (customQuestions.length > 0) {
        setCustomQuestions([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [noOfCustomQuestions, interviewType]);

  const handleAddQuestion = () => {
    if (interviewType === "Manual HR interview") {
      alert(
        "For predefined interviews, use Total Questions to control question count.",
      );
      return;
    }
    if (customQuestions.length >= 20) {
      return alert("You can add maximum 20 questions");
    }
    if (customQuestions.length >= 5 && interviewType === "AI HR interview") {
      return alert("You can add maximum 5 questions ");
    }
    setCustomQuestions([...customQuestions, ""]);
  };

  const handleRemoveQuestion = (index) => {
    setCustomQuestions(customQuestions.filter((_, i) => i !== index));
    RecuiterStore.setHrInterviewDetails(
      "customquestions",
      customQuestions.filter((_, i) => i !== index),
    );

    if (interviewType !== "AI HR interview") {
      setNoOfQuestions(customQuestions.length - 1);
    }
  };

  const getInterviewId = (interviewType) => {
    console.log(interviewType);
    const interviewId = interviewsProList.find(
      (interview) => interview.title === interviewType,
    )?.interviewId;
    return interviewId;
  };

  const handlePopUpVisible = (value) => {
    setPopupVisible(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate custom questions for AI HR interviews
    if (
      interviewType === "AI HR interview" &&
      Number(noOfCustomQuestions || 0) > 0
    ) {
      const customCount = Number(noOfCustomQuestions || 0);

      // Check if length matches
      if (customQuestions.length !== customCount) {
        alert(
          `Please provide exactly ${customCount} custom question${
            customCount !== 1 ? "s" : ""
          }. Currently you have ${customQuestions.length} question${
            customQuestions.length !== 1 ? "s" : ""
          }.`,
        );
        return;
      }

      // Check if all custom questions are filled
      const emptyIndices = [];
      customQuestions.forEach((q, idx) => {
        if (q.trim() === "") {
          emptyIndices.push(idx + 1);
        }
      });

      if (emptyIndices.length > 0) {
        alert(
          `Please fill in all custom questions. Question${
            emptyIndices.length !== 1 ? "s" : ""
          } ${emptyIndices.join(", ")} ${
            emptyIndices.length !== 1 ? "are" : "is"
          } empty.`,
        );
        return;
      }
    }

    setIsLoading(true);
    InterviewStore.setCompanyInterview(true);
    RecuiterStore.setHrInterviewDetails("numberOfQuestions", noOfQuestions);
    RecuiterStore.setHrInterviewDetails("interviewLevel", level);
    RecuiterStore.setHrInterviewDetails("customquestions", customQuestions);
    RecuiterStore.setHrInterviewDetails("technology", technology);
    RecuiterStore.sethrAdditionalSettings("attempts", attempts);
    RecuiterStore.setHrInterviewDetails("interviewType", interviewType);
    RecuiterStore.setHrInterviewDetails(
      "noOfIntroQuestions",
      noOfIntroQuestions || 0,
    );
    RecuiterStore.setHrInterviewDetails(
      "noOfFollowUps",
      noOfFollowupQuestions || 0,
    );
    RecuiterStore.setHrInterviewDetails("allQuestions", allQuestions || 0);
    RecuiterStore.setHrInterviewDetails(
      "noOfCustomQuestions",
      noOfCustomQuestions || 0,
    );
    let resumeLink = null;

    const userDetails = UserStore.userDetails;
    let response = null;
    try {
      const customSettings = JSON.parse(localStorage.getItem("customSettings"));
      const id = JSON.parse(localStorage.getItem("interviewId"));
      console.log(userDetails);
      console.log(id);
      const body = {
        userId: userDetails._id,
        attempts: customSettings[3].value,
        invitationFrom: id,
      };
      setAttempts(customSettings[3].value);
      response = await apiPostPut(
        body,
        "/interview/validate-custom-settings",
        "POST",
      );
      console.log("validation", response);
    } catch (error) {}

    if (
      userDetails?.role?.role != "company" &&
      userDetails?.role?.role != "consultancy"
    ) {
      // check resume uploaded or not for resume based interview for user or students
      const idOfResumeBasedInterviews = [2, 4, 8];
      if (
        idOfResumeBasedInterviews.includes(
          InterviewStore.interviewSettings?.id ??
            InterviewStore.interviewSettings?.interviewId,
        )
      ) {
        if (InterviewStore.resumeFile === null) {
          return alert("Please upload your resume");
        }

        const resumeFileName = Date.now() + InterviewStore.resumeFile?.name;

        const resumeUploadResponse = await uploadFileToAzure(
          resumeFileName,
          InterviewStore.resumeFile,
          { action: "interview" },
        );
        if (resumeUploadResponse?.success) {
          resumeLink = resumeUploadResponse?.url;
        }
      }
    }
    if (Number(noOfQuestions) === 0) {
      setIsLoading(false);
      return alert("The number of question should be greater than 0 ");
    }

    let interviewDetails = {
      // name: name,
      interviewId: getInterviewId(interviewType),
      technology: technology,
      levelOfInterview: level === "" ? "low" : level,
      noOfQuestions: Number(noOfQuestions),
      noOfIntroQuestions: Number(noOfIntroQuestions || 0),
      noOfFollowUps: Number(noOfFollowupQuestions || 0),
      noOfCustomQuestions: Number(noOfCustomQuestions || 0),
      allQuestions:
        Number(allQuestions || 0) ||
        Number(noOfQuestions || 0) +
          Number(noOfIntroQuestions || 0) +
          Number(noOfFollowupQuestions || 0) +
          Number(noOfCustomQuestions || 0),
      // role: role,
      // company: company,
      customQuestions: customQuestions,
      // resume: InterviewStore.resumeFile,
      resume: InterviewStore.resumeText,
    };
    if (InterviewStore.companyInterview) {
      console.log(
        "companyInterview",
        RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings,
      );
      interviewDetails.customSettings = [
        {
          name: "video",
          value:
            RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
              .camera,
        },
        {
          name: "resume",
          value:
            RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
              .resume,
        },
        {
          name: "screen",
          value:
            RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
              .screen,
        },
        {
          name: "attempts",
          value:
            RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
              .attempts,
        },
      ];
      console.log("hello", interviewDetails);
    }
    if (resumeLink !== null) {
      interviewDetails["resumeLink"] = resumeLink;
    }

    console.log(userDetails);
    // return;

    if (
      userDetails?.role?.role === "company" ||
      userDetails?.role?.role === "consultancy"
    ) {
      // InterviewStore.changeInterviewIdByIdForResume(
      //   InterviewStore.interviewSettings?.id
      // );
      interviewDetails["interviewer"] = userDetails?._id;
      interviewDetails["interviewType"] = "real";
      InterviewStore.updateInterviewDetails(interviewDetails);

      let body = {
        ...InterviewStore.interviewSettings,
        isInvitation: true,
        model: 3,
        whoPay: !RecuiterStore.jobPostDetails.technicalInterviewDetails
          .whoPayCheck
          ? "company"
          : "candidate",
      };

      delete body.id;
      if (RecuiterStore.clientId) {
        body.client = RecuiterStore.clientId;
      }

      console.log(body);

      setWaiting(true);
      let apiResponse = null;
      alert(level, "level");
      if (id) {
        apiResponse = await updateInterview(id, body);
      } else {
        apiResponse = await createInterview(body);
      }
      setWaiting(false);
      setIsLoading(false);
      console.log(apiResponse);
      if (
        (apiResponse.status === 200 || apiResponse.status === 201) &&
        apiResponse.body?.success
      ) {
        alert("Interview-invitation created successfully");
        alert(level, "level");

        const data = apiResponse.body?.data;
        const invitationId = data?._id;
        const interviewId = data?.interviewId;
        console.log(data?.interviewLink);
        setInvitationLink(
          getDomainForWhiteLabeling() === "app.reaidy.io"
            ? `https://user.reaidy.io/interview-creation/8?meetingid=${invitationId}`
            : `https://${getDomainForWhiteLabeling()}/share?page=interview_invitation&id=${invitationId}`,
        );
        setClientLink(
          `https://${getDomainForWhiteLabeling()}/share/applicants?id=${invitationId}`,
        );
        setPopupVisible(true);
      } else {
        alert(level, "level");
        alert(apiResponse?.body?.message);
      }

      return;
    }

    // localStorage.setItem("interviewDetails", JSON.stringify(interviewDetails));
    InterviewStore.updateInterviewDetails(interviewDetails);
    console.log(InterviewStore.interviewDetails);
    // navigate(
    //   `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`
    // );
    // Construct the new URL
    const newURL = `/interview?technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`;

    // Set the new URL and trigger a reload
    console.log(response);
    console.log(InterviewStore.companyInterview, "companyInterview");

    if (!InterviewStore.validation) {
      window.location.href = newURL;
      return;
    }
    if (response.status === 200) {
      window.location.href = newURL;
    } else {
      alert(response.body.message);
    }
  };

  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = invitationLink;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert("HR interview link copied");
  };

  const handleHRSubmit = (e) => {
    e.preventDefault();
    setValidationError("");
    if (interviewType === "AI HR interview") {
      if (!allQuestions) {
        setValidationError("Please select total questions.");
        return;
      }
      const totalSelected = Number(allQuestions);
      const topic = Number(noOfQuestions || 0);
      const intro = Number(noOfIntroQuestions || 0);
      const follow = Number(noOfFollowupQuestions || 0);
      const custom = Number(noOfCustomQuestions || 0);
      if (topic + intro + follow + custom !== totalSelected) {
        setValidationError(
          "Topic, introduction, follow-up, and custom counts must add up to your selected total. Open question distribution and adjust the counts.",
        );
        return;
      }
    }
    if (
      customQuestions.length + Number(noOfQuestions) > 20 &&
      interviewType === "AI HR interview"
    ) {
      setValidationError(
        "Additional questions & Number of questions should be less than or equal to 20",
      );
      return;
    }

    // Validate all questions are filled for Manual HR (Predefined) interviews
    if (interviewType === "Manual HR interview") {
      const emptyIndices = [];
      customQuestions.forEach((q, idx) => {
        if (!q || q.trim() === "") {
          emptyIndices.push(idx + 1);
        }
      });

      if (emptyIndices.length > 0) {
        setValidationError(
          `Please fill in all questions before proceeding. Question${
            emptyIndices.length !== 1 ? "s" : ""
          } ${emptyIndices.join(", ")} ${
            emptyIndices.length !== 1 ? "are" : "is"
          } empty.`,
        );
        return;
      }
    }

    // Validate custom questions for AI HR interviews
    if (
      interviewType === "AI HR interview" &&
      Number(noOfCustomQuestions || 0) > 0
    ) {
      const customCount = Number(noOfCustomQuestions || 0);

      // Check if length matches
      if (customQuestions.length !== customCount) {
        setValidationError(
          `Please provide exactly ${customCount} custom question${
            customCount !== 1 ? "s" : ""
          }. Currently you have ${customQuestions.length} question${
            customQuestions.length !== 1 ? "s" : ""
          }.`,
        );
        return;
      }

      // Check if all custom questions are filled
      const emptyIndices = [];
      customQuestions.forEach((q, idx) => {
        if (q.trim() === "") {
          emptyIndices.push(idx + 1);
        }
      });

      if (emptyIndices.length > 0) {
        setValidationError(
          `Please fill in all custom questions. Question${
            emptyIndices.length !== 1 ? "s" : ""
          } ${emptyIndices.join(", ")} ${
            emptyIndices.length !== 1 ? "are" : "is"
          } empty.`,
        );
        return;
      }
    }
    console.log("HR", interviewType, noOfQuestions, level);
    RecuiterStore.setHrInterviewDetails("interviewType", interviewType);
    if (interviewType === "AI HR interview") {
      RecuiterStore.setHrInterviewDetails("interviewId", 8);
    } else {
      RecuiterStore.setHrInterviewDetails("interviewId", 11);
    }
    RecuiterStore.setHrInterviewDetails("technology", technology);
    RecuiterStore.setHrInterviewDetails("numberOfQuestions", noOfQuestions);
    RecuiterStore.setHrInterviewDetails("interviewLevel", level);
    RecuiterStore.setHrInterviewDetails("customquestions", customQuestions);
    RecuiterStore.sethrAdditionalSettings("attempts", attempts);
    RecuiterStore.setHrInterviewDetails(
      "noOfIntroQuestions",
      noOfIntroQuestions || 0,
    );
    RecuiterStore.setHrInterviewDetails(
      "noOfFollowUps",
      noOfFollowupQuestions || 0,
    );
    RecuiterStore.setHrInterviewDetails("allQuestions", allQuestions || 0);
    RecuiterStore.setHrInterviewDetails(
      "noOfCustomQuestions",
      noOfCustomQuestions || 0,
    );
    CommonStore.setProgress(interview ? 1 : 5);
    CommonStore.setLabelActive(interview ? 0 : 4, true);
    RecuiterStore.setHrInterviewDetails("skipped", false);
  };
  const setCutOff = (value) => {
    // Define the setCutOff function here
  };

  const setCutOffValue = (value) => {
    RecuiterStore.setHrInterviewDetails("resumeCutoff", value);
  };

  return useObserver(() => (
    <>
      <HelpCenter />
      {isLoading && <Loader loader={true} text={"Loading..."} />}
      <div
        className={`w-full overflow-hidden ${
          !showSkip ? " flex flex-col items-center justify-center" : null
        } `}
      >
        {!interview && (
          <div
            className={` w-[90%] mx-auto flex ${
              showSkip ? "justify-between" : "justify-center"
            }`}
          >
            {/* {showSkip && <p></p>} */}

            <p className="text-xl font-semibold text-black mb-2 md:block mt-10 lg:block md:ml-8 hidden">
              {fromIndex ? "Create" : "Add"} HR Interview
            </p>
            {showSkip && (
              <>
                {RecuiterStore.jobPostDetails.hrInterviewDetails.skipped &&
                isEdit ? (
                  <div className="flex gap-2 flex-col">
                    <button
                      type="button"
                      // onClick={() => setShowPopup(true)}
                      className="text-gray-400 underline cursor-not-allowed"
                    >
                      Skip Section
                    </button>
                    <p className="text-primary">This section is skipped</p>
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => setShowPopup(true)}
                    className="text-primary underline ml-56 md:mt-10 mt-4"
                  >
                    Skip Section
                  </button>
                )}
              </>
            )}
          </div>
        )}
        <p className="text-xl font-semibold md:hidden lg:hidden block text-center -mt-6 md:mt-0 lg:mt-0 text-black sm:flex sm:justify-start ml-5 ">
          {fromIndex ? (id ? "Update" : "Create") : "Add"} HR Interview
        </p>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            fromIndex ? handleSubmit(e) : handleHRSubmit(e);
          }}
          className="w-[90%] mx-auto mt-2"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-1 md:gap-6 w-full mx-auto">
            <div>
              <Select
                label="Type of Interview"
                required={true}
                placeholder="Select Interview Type AI Interview/Manual Interview"
                value={interviewType}
                action={(e) => {
                  if (RecuiterStore.jobPostDetails.hrInterviewDetails.skipped) {
                    RecuiterStore.setHrInterviewDetails("skipped", false);
                    CommonStore.setLabelSkipped(4, false);
                  }
                  setInterviewType(e.target.value);
                  RecuiterStore.setHrInterviewDetails(
                    "interviewType",
                    e.target.value,
                  );

                  if (e.target.value === "AI HR interview") {
                    setCustomQuestions([]);
                  }
                }}
                options={[
                  { value: "AI HR interview", label: "AI-Generated Interview" },
                  {
                    value: "Manual HR interview",
                    label: "Predefined Interview",
                  },
                ]}
              />
            </div>
            {/* <div>
              <Input
                label="Topic of Interview(Technology)"
                type="text"
                placeholder="Select Technology Name"
                defaultValue={RecuiterStore.jobPostDetails.hrInterviewDetails.technology || ""}
                action={(e) => {
                  setTechnology(e.target.value);
                  RecuiterStore.setTechnicalInterviewDetails(
                    "technology",
                    e.target.value 
                  );
                }}
              />
            </div> */}
            <div>
              <Select
                label="Total Questions"
                placeholder="Select Total Questions"
                value={allQuestions ? String(allQuestions) : ""}
                required={true}
                action={(e) => {
                  if (RecuiterStore.jobPostDetails.hrInterviewDetails.skipped) {
                    RecuiterStore.setHrInterviewDetails("skipped", false);
                    CommonStore.setLabelSkipped(4, false);
                  }
                  const total = Number(e.target.value || 0);
                  setAllQuestions(e.target.value);
                  RecuiterStore.setHrInterviewDetails(
                    "allQuestions",
                    e.target.value,
                  );

                  if (interviewType === "Manual HR interview") {
                    // For Manual, assign all to Topic
                    setNoOfQuestions(String(total));
                    setNoOfIntroQuestions("0");
                    setNoOfFollowupQuestions("0");
                    setNoOfCustomQuestions("0");
                    RecuiterStore.setHrInterviewDetails(
                      "numberOfQuestions",
                      String(total),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfIntroQuestions",
                      "0",
                    );
                    RecuiterStore.setHrInterviewDetails("noOfFollowUps", "0");
                    RecuiterStore.setHrInterviewDetails(
                      "noOfCustomQuestions",
                      "0",
                    );
                    setShowCustom(false);
                  } else {
                    // For AI, distribute: 60% topic, 20% intro, 20% follow
                    const topic = Math.floor(total * 0.6);
                    const intro = Math.floor(total * 0.2);
                    const follow = Math.max(0, total - topic - intro);

                    // Store original values BEFORE distribution (for cancel)
                    setOriginalTopic(Number(topic || 0));
                    setOriginalIntro(Number(intro || 0));
                    setOriginalFollow(Number(follow || 0));

                    // Update state immediately with distributed values
                    setNoOfQuestions(String(topic));
                    setNoOfIntroQuestions(String(intro));
                    setNoOfFollowupQuestions(String(follow));
                    setNoOfCustomQuestions("0");
                    RecuiterStore.setHrInterviewDetails(
                      "numberOfQuestions",
                      String(topic),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfIntroQuestions",
                      String(intro),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfFollowUps",
                      String(follow),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfCustomQuestions",
                      "0",
                    );

                    // Sync dialog state with component state
                    setDistTotal(total);
                    setDistTopic(topic);
                    setDistIntro(intro);
                    setDistFollow(follow);
                    setDistCustom(0);
                    setShowCustom(false);

                    setDistOpen(true);
                  }
                }}
                options={[
                  { value: "5", label: "5 Questions" },
                  { value: "10", label: "10 Questions" },
                  { value: "15", label: "15 Questions" },
                ]}
              />
            </div>
            {/* <div>
              <Input
                label="No. of Attempts"
                type="number"
                defaultValue={
                  RecuiterStore.jobPostDetails.hrInterviewDetails
                    .additionalSettings.attempts 
                }
                action={(e) => {
                  if (RecuiterStore.jobPostDetails.hrInterviewDetails.skipped) {
                    RecuiterStore.setHrInterviewDetails("skipped", false);
                     CommonStore.setLabelSkipped(4, false);
                  }
                  setAttempts(e.target.value);
                  RecuiterStore.sethrAdditionalSettings(
                    "attempts",
                    e.target.value
                  );
                }}
              />
            </div> */}
            <div>
              <PercentageInput
                label="Cut off %(Optional)"
                type="number"
                placeholder="Enter cut-off in %"
                setValue={setCutOffValue}
                defaultValue={
                  RecuiterStore?.jobPostDetails?.hrInterviewDetails
                    ?.resumeCutoff
                }
                tooltip="If you Set the cut-off Percentage, our AI will analyze resumes based on the JD and filter candidates accordingly."
                action={(e) => {
                  if (RecuiterStore.jobPostDetails.hrInterviewDetails.skipped) {
                    RecuiterStore.setHrInterviewDetails("skipped", false);
                    CommonStore.setLabelSkipped(4, false);
                  }
                  RecuiterStore.setHrInterviewDetails(
                    "resumeCutoff",
                    e.target.value,
                  );
                }}
              />
            </div>
            {interviewType === "AI HR interview" && (
              <div>
                <Select
                  label="Select Level"
                  placeholder="Select Level"
                  required={true}
                  value={level}
                  action={(e) => {
                    if (
                      RecuiterStore.jobPostDetails.hrInterviewDetails.skipped
                    ) {
                      RecuiterStore.setHrInterviewDetails("skipped", false);
                      CommonStore.setLabelSkipped(4, false);
                    }
                    setLevel(e.target.value);
                    RecuiterStore.setHrInterviewDetails(
                      "interviewLevel",
                      e.target.value,
                    );
                  }}
                  options={[
                    { value: "low", label: "Low" },
                    { value: "medium", label: "Medium" },
                    { value: "high", label: "High" },
                  ]}
                />
              </div>
            )}
          </div>

          {/* Question Distribution Display - Only for AI HR Interview */}
          {allQuestions && interviewType === "AI HR interview" && (
            <div className="w-full mt-4 md:w-[94%]">
              <div className="font-semibold mb-2 flex items-center gap-2">
                Questions Distribution
              </div>
              <div
                className={`grid grid-cols-1 gap-2 ${
                  showCustom || Number(noOfCustomQuestions || 0) > 0
                    ? "md:grid-cols-4"
                    : "md:grid-cols-3"
                }`}
              >
                <div
                  className="flex items-center justify-between p-2 px-4 border rounded-md gap-2 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => {
                    const currentTopic = Number(noOfQuestions || 0);
                    const currentIntro = Number(noOfIntroQuestions || 0);
                    const currentFollow = Number(noOfFollowupQuestions || 0);
                    const currentCustom = Number(noOfCustomQuestions || 0);
                    // Store original values for cancel
                    setOriginalTopic(currentTopic);
                    setOriginalIntro(currentIntro);
                    setOriginalFollow(currentFollow);
                    // Sync dialog state with current component state
                    setDistTotal(Number(allQuestions || 0));
                    setDistTopic(currentTopic);
                    setDistIntro(currentIntro);
                    setDistFollow(currentFollow);
                    setDistCustom(currentCustom);
                    setShowCustom(currentCustom > 0);
                    setDistOpen(true);
                  }}
                  title="Click to adjust question counts"
                >
                  <span className="text-sm">Topic</span>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">{noOfQuestions || 0}</span>
                    <svg
                      className="w-3 h-3 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  className="flex items-center justify-between p-2 px-4 border rounded-md gap-2 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => {
                    const currentTopic = Number(noOfQuestions || 0);
                    const currentIntro = Number(noOfIntroQuestions || 0);
                    const currentFollow = Number(noOfFollowupQuestions || 0);
                    const currentCustom = Number(noOfCustomQuestions || 0);
                    // Store original values for cancel
                    setOriginalTopic(currentTopic);
                    setOriginalIntro(currentIntro);
                    setOriginalFollow(currentFollow);
                    // Sync dialog state with current component state
                    setDistTotal(Number(allQuestions || 0));
                    setDistTopic(currentTopic);
                    setDistIntro(currentIntro);
                    setDistFollow(currentFollow);
                    setDistCustom(currentCustom);
                    setShowCustom(currentCustom > 0);
                    setDistOpen(true);
                  }}
                  title="Click to adjust question counts"
                >
                  <span className="text-sm">Introduction</span>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">
                      {noOfIntroQuestions || 0}
                    </span>
                    <svg
                      className="w-3 h-3 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  className="flex items-center justify-between p-2 px-4 border rounded-md gap-2 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => {
                    const currentTopic = Number(noOfQuestions || 0);
                    const currentIntro = Number(noOfIntroQuestions || 0);
                    const currentFollow = Number(noOfFollowupQuestions || 0);
                    const currentCustom = Number(noOfCustomQuestions || 0);
                    // Store original values for cancel
                    setOriginalTopic(currentTopic);
                    setOriginalIntro(currentIntro);
                    setOriginalFollow(currentFollow);
                    // Sync dialog state with current component state
                    setDistTotal(Number(allQuestions || 0));
                    setDistTopic(currentTopic);
                    setDistIntro(currentIntro);
                    setDistFollow(currentFollow);
                    setDistCustom(currentCustom);
                    setShowCustom(currentCustom > 0);
                    setDistOpen(true);
                  }}
                  title="Click to adjust question counts"
                >
                  <span className="text-sm">Follow Up</span>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">
                      {noOfFollowupQuestions || 0}
                    </span>
                    <svg
                      className="w-3 h-3 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </div>
                </div>
                {showCustom || Number(noOfCustomQuestions || 0) > 0 ? (
                  <div
                    className="flex items-center justify-between p-2 px-4 border rounded-md gap-2 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={() => {
                      const currentTopic = Number(noOfQuestions || 0);
                      const currentIntro = Number(noOfIntroQuestions || 0);
                      const currentFollow = Number(noOfFollowupQuestions || 0);
                      const currentCustom = Number(noOfCustomQuestions || 0);
                      setDistTotal(Number(allQuestions || 0));
                      setDistTopic(currentTopic);
                      setDistIntro(currentIntro);
                      setDistFollow(currentFollow);
                      setDistCustom(currentCustom);
                      setShowCustom(true);
                      // Store original values for cancel
                      setOriginalTopic(currentTopic);
                      setOriginalIntro(currentIntro);
                      setOriginalFollow(currentFollow);
                      setDistOpen(true);
                    }}
                    title="Click to adjust question counts"
                  >
                    <span className="text-sm">Custom</span>
                    <div className="flex items-center gap-2">
                      <span className="font-medium">
                        {noOfCustomQuestions || 0}
                      </span>
                      <svg
                        className="w-3 h-3 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </div>
                  </div>
                ) : (
                  <button
                    type="button"
                    className="flex items-center justify-center gap-2 p-2 px-4 border border-dashed rounded-md transition-colors hover:bg-gray-50 border-gray-300 hover:border-primary"
                    onClick={() => {
                      const currentTopic = Number(noOfQuestions || 0);
                      const currentIntro = Number(noOfIntroQuestions || 0);
                      const currentFollow = Number(noOfFollowupQuestions || 0);
                      setShowCustom(true);
                      setDistTotal(Number(allQuestions || 0));
                      setDistTopic(currentTopic);
                      setDistIntro(currentIntro);
                      setDistFollow(currentFollow);
                      setDistCustom(0);
                      setDistOpen(true);
                    }}
                    title="Add custom questions"
                  >
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    <span className="text-sm text-gray-600">Custom</span>
                  </button>
                )}
              </div>
              {(() => {
                const topicQuestions = Number(noOfQuestions || 0);
                const introQuestions = Number(noOfIntroQuestions || 0);
                const followUpQuestions = Number(noOfFollowupQuestions || 0);
                const customQuestions = Number(noOfCustomQuestions || 0);
                const total =
                  topicQuestions +
                  introQuestions +
                  followUpQuestions +
                  customQuestions;
                const selectedTotal = Number(allQuestions || 0);
                const difference = selectedTotal - total;
                const isValid = total === selectedTotal;
                return (
                  <div
                    className={`mt-2 p-2 rounded-md text-sm ${
                      isValid
                        ? "bg-green-50 text-green-700 border border-green-200"
                        : "bg-blue-50 text-blue-700 border border-blue-200"
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <span>
                        Total: {total} questions
                        {selectedTotal > 0 && ` (Selected: ${selectedTotal})`}
                      </span>
                      {!isValid && selectedTotal > 0 && (
                        <span className="text-xs">
                          {total < selectedTotal
                            ? `${difference} questions available`
                            : `${total - selectedTotal} too many`}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })()}
            </div>
          )}

          <div className="mt-8">
            {customQuestions.map((question, index) => (
              <div key={index} className="flex items-center gap-4">
                <Input
                  label={
                    interviewType === "Manual HR interview"
                      ? `Question ${index + 1}`
                      : `Additional question ${index + 1}`
                  }
                  placeholder="Enter Question here"
                  defaultValue={question}
                  questionMark={true}
                  action={(e) => {
                    if (
                      RecuiterStore.jobPostDetails.hrInterviewDetails.skipped
                    ) {
                      RecuiterStore.setHrInterviewDetails("skipped", false);
                      CommonStore.setLabelSkipped(4, false);
                    }
                    const newQuestions = [...customQuestions];
                    newQuestions[index] = e.target.value;
                    setCustomQuestions(newQuestions);
                    RecuiterStore.setHrInterviewDetails(
                      "customquestions",
                      newQuestions.filter((e) => e !== ""),
                    );
                  }}
                />
                <MdDeleteOutline
                  onClick={() => handleRemoveQuestion(index)}
                  className="cursor-pointer text-xl mt-7 text-red-500"
                />
              </div>
            ))}
          </div>
          <div
            className="flex justify-between mt-0 md:mt-20 md:mb-8 lg:mt-20
          
          
          mb-20  "
          >
            {showSkip && (
              <button
                type="button"
                className="text-primary flex items-center gap-2 mb-3 md:mt-0 lg:mt-0 md:mb-0 lg:mb-0"
                onClick={() => CommonStore.setProgress(3)}
              >
                <AiOutlineLeft /> Back
              </button>
            )}
            {validationError && (
              <p className="text-red-500 text-sm mb-3 text-right">
                {validationError}
              </p>
            )}
            <PrimaryButton
              buttonName={buttonName || "Next"}
              type={
                RecuiterStore.jobPostDetails.hrInterviewDetails.skipped &&
                isEdit
                  ? "button"
                  : "submit"
              }
              onClick={() => {
                if (
                  RecuiterStore.jobPostDetails.hrInterviewDetails.skipped &&
                  isEdit
                ) {
                  RecuiterStore.setHrInterviewDetails("skipped", true);
                  CommonStore.setProgress(5);
                  CommonStore.setLabelActive(4, false);
                  CommonStore.setLabelSkipped(4, true);
                } else {
                  CommonStore.setLabelSkipped(4, false);
                  RecuiterStore.setHrInterviewDetails("skipped", false);
                }
              }}
              width="w-fit"
              rounded="lg"
              padding={10}
            />
          </div>
        </form>

        {/* Distribution Dialog */}
        {distOpen && interviewType === "AI HR interview" && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] md:w-[60%] lg:w-[50%] max-w-2xl">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Distribute Questions</h3>
                <button
                  onClick={() => {
                    // Revert to original values on cancel
                    setNoOfQuestions(String(originalTopic));
                    setNoOfIntroQuestions(String(originalIntro));
                    setNoOfFollowupQuestions(String(originalFollow));
                    setNoOfCustomQuestions("0");
                    RecuiterStore.setHrInterviewDetails(
                      "numberOfQuestions",
                      String(originalTopic),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfIntroQuestions",
                      String(originalIntro),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfFollowUps",
                      String(originalFollow),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfCustomQuestions",
                      "0",
                    );
                    setShowCustom(false);
                    setDistOpen(false);
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-4">
                Set Topic, Introduction, Follow Up and Custom counts. Total:{" "}
                {distTotal}
              </p>
              <div
                className={`grid grid-cols-1 gap-3 mb-4 ${
                  showCustom ? "md:grid-cols-4" : "md:grid-cols-3"
                }`}
              >
                <div className="flex flex-col gap-2 p-3 border rounded-md">
                  <label className="text-sm font-medium">Topic</label>
                  <input
                    type="number"
                    min={0}
                    value={Number(noOfQuestions || 0)}
                    onChange={(e) => {
                      const newValue = Number(e.target.value || 0);
                      // Update state in real-time
                      setNoOfQuestions(String(newValue));
                      setDistTopic(newValue);
                      RecuiterStore.setHrInterviewDetails(
                        "numberOfQuestions",
                        String(newValue),
                      );
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>
                <div className="flex flex-col gap-2 p-3 border rounded-md">
                  <label className="text-sm font-medium">Introduction</label>
                  <input
                    type="number"
                    min={0}
                    value={Number(noOfIntroQuestions || 0)}
                    onChange={(e) => {
                      const newValue = Number(e.target.value || 0);
                      // Update state in real-time
                      setNoOfIntroQuestions(String(newValue));
                      setDistIntro(newValue);
                      RecuiterStore.setHrInterviewDetails(
                        "noOfIntroQuestions",
                        String(newValue),
                      );
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>
                <div className="flex flex-col gap-2 p-3 border rounded-md">
                  <label className="text-sm font-medium">Follow Up</label>
                  <input
                    type="number"
                    min={0}
                    value={Number(noOfFollowupQuestions || 0)}
                    onChange={(e) => {
                      const newValue = Number(e.target.value || 0);
                      // Update state in real-time
                      setNoOfFollowupQuestions(String(newValue));
                      setDistFollow(newValue);
                      RecuiterStore.setHrInterviewDetails(
                        "noOfFollowUps",
                        String(newValue),
                      );
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>
                {showCustom ? (
                  <div className="flex flex-col gap-2 p-3 border rounded-md">
                    <label className="text-sm font-medium">Custom</label>
                    <input
                      type="number"
                      min={0}
                      value={Number(noOfCustomQuestions || 0)}
                      onChange={(e) => {
                        const newValue = Number(e.target.value || 0);
                        setDistCustom(newValue);
                        // Update state in real-time
                        setNoOfCustomQuestions(String(newValue));
                        RecuiterStore.setHrInterviewDetails(
                          "noOfCustomQuestions",
                          String(newValue),
                        );
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                  </div>
                ) : (
                  <button
                    type="button"
                    className="flex items-center justify-center gap-2 p-3 border border-dashed rounded-md transition-colors hover:bg-gray-50 border-gray-300 hover:border-primary"
                    onClick={() => setShowCustom(true)}
                  >
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    <span className="text-sm text-gray-600">Custom</span>
                  </button>
                )}
              </div>
              <div className="text-xs text-gray-500 mb-4">
                Remaining:{" "}
                {Math.max(
                  0,
                  distTotal -
                    (Number(noOfQuestions || 0) +
                      Number(noOfIntroQuestions || 0) +
                      Number(noOfFollowupQuestions || 0) +
                      Number(noOfCustomQuestions || 0)),
                )}
              </div>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => {
                    // Revert to original values on cancel
                    setNoOfQuestions(String(originalTopic));
                    setNoOfIntroQuestions(String(originalIntro));
                    setNoOfFollowupQuestions(String(originalFollow));
                    setNoOfCustomQuestions("0");
                    RecuiterStore.setHrInterviewDetails(
                      "numberOfQuestions",
                      String(originalTopic),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfIntroQuestions",
                      String(originalIntro),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfFollowUps",
                      String(originalFollow),
                    );
                    RecuiterStore.setHrInterviewDetails(
                      "noOfCustomQuestions",
                      "0",
                    );
                    setShowCustom(false);
                    setDistOpen(false);
                  }}
                  className="px-4 py-2 border rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    const topic = Number(noOfQuestions || 0);
                    const intro = Number(noOfIntroQuestions || 0);
                    const follow = Number(noOfFollowupQuestions || 0);
                    const custom = Number(noOfCustomQuestions || 0);
                    const sum = topic + intro + follow + custom;
                    if (
                      sum !== distTotal ||
                      topic < 0 ||
                      intro < 0 ||
                      follow < 0 ||
                      custom < 0
                    ) {
                      alert("Counts must sum to total and be non-negative.");
                      return;
                    }
                    // Keep custom visible if it was already shown or if value is > 0
                    setShowCustom(custom > 0 || showCustom);
                    // Values are already updated in real-time, just close the dialog
                    setDistOpen(false);
                  }}
                  className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}

        {showPopup && (
          // <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          //   <div className="bg-[#F3F3F3] p-6 rounded-lg shadow-lg w-[90%] max-w-md">
          //     <div className="flex flex-col items-center">
          //       <MdWarning className="text-3xl text-gray-500" />
          //       <p className="  mt-4">
          //         Please fill in the details to move to the next section / click
          //         on skip section
          //       </p>
          //     </div>
          //     <div className="mt-6 w-[60%] mx-auto flex justify-between">
          //       <button
          //         className="underline"
          //         onClick={() => {
          //           RecuiterStore.setHrInterviewDetails("skipped", true);
          //           setShowPopup(false);
          //           CommonStore.setProgress(4);
          //           CommonStore.setLabelActive(3, false);
          //         }}>
          //         Skip Section
          //       </button>
          //       <button
          //         className="text-primary underline"
          //         onClick={() => setShowPopup(false)}>
          //         Fill details
          //       </button>
          //     </div>
          //   </div>
          // </div>
          <Popup
            onSkip={() => {
              RecuiterStore.setHrInterviewDetails("skipped", true);
              setShowPopup(false);
              CommonStore.setProgress(5);
              CommonStore.setLabelActive(4, false);
              CommonStore.setLabelSkipped(4, true);
            }}
            onFillDetails={() => setShowPopup(false)}
          />
        )}
        {invitationLink !== null && !waiting && popUpVisible && (
          // <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center gap-8 bg-gray-500 bg-opacity-20 z-50">
          //   <div className="bg-white p-4 py-10 relative flex items-center justify-center w-[90%] md:w-[40%] lg:w-[40%]">
          //     <AiOutlineClose
          //       onClick={() => setWaiting(true)}
          //       className="absolute right-2 top-2 cursor-pointer"
          //     />
          //     <div className="flex flex-col w-full">
          //       <label className="text-primary text-xl pb-2">
          //         Copy the link
          //       </label>
          //       <textarea
          //         className="w-full h-auto p-2 focus:outline-none rounded-lg bg-gray-200"
          //         value={invitationLink}
          //       />
          //     </div>
          //     <span
          //       className="flex text-gray-800 cursor-pointer w-5 h-5 md:mt-[4%] lg:mt-[4%] mt-[5%]  hover:text-gray-400 duration-200"
          //       onClick={handleCopyClick}>
          //       {" "}
          //       <AiOutlineCopy className="text-xl active:text-primary" />
          //     </span>
          //   </div>
          // </div>
          <JobShare
            link={link()}
            emailBody={`Here is the interview link : ${invitationLink}`}
            emailSubject={""}
            isPopupVisible={popUpVisible}
            handlePopUpVisible={handlePopUpVisible}
            interview="HR Interview"
          />
        )}
      </div>
    </>
  ));
}
